import {useEffect, useState} from "react";

/**
 * Verzögert einen Wert um "delay" Millisekunden - für die Freitextsuche der
 * Differenzansicht Zuständigkeit, damit nicht bei jedem Tastendruck ein
 * Server-Abruf ausgelöst wird.
 */
export default function useDebouncedValue(value, delay = 400) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);

    return debounced;
}
